import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-100">
      <div className="max-w-2xl mx-auto text-center" data-id="element-101">
        <div className="flex justify-center mb-6" data-id="element-102">
          <ShieldCheck className="w-20 h-20 text-green-500" data-id="element-103" />
        </div>

        <div className="text-xl md:text-2xl text-gray-700 font-medium space-y-4" data-id="element-104">
          <p data-id="element-105">Probalo durante 30 días.</p>
          <p data-id="element-106">Si no es para vos, te devolvemos el 100% del dinero.</p>

          <div className="pt-6 font-bold text-gray-900 text-2xl" data-id="element-107">
            <p data-id="element-108">Sin preguntas. Sin vueltas.</p>
          </div>
        </div>
      </div>
    </section>;
}